export const schemas = {
  'vantiv-tripos-golang-microservice': [
    { key: 'AcceptorId', type: 'string' },
    { key: 'AccountId', type: 'string' },
    { key: 'AccountToken', type: 'string' },
    { key: 'CurrencyCode', type: 'string' },
    { key: 'BillingAddress1', type: 'string' },
    { key: 'BillingAddress2', type: 'string' },
    { key: 'BillingCity', type: 'string' },
    { key: 'BillingPostalCode', type: 'string' },
    { key: 'BillingState', type: 'string' },
    { key: 'MarketCode', type: 'string' },
    { key: 'IsGiftSupported', type: 'boolean' },
    { key: 'AllowDebit', type: 'boolean' },
    { key: 'AllowPartialApprovals', type: 'boolean' },
    { key: 'CheckForDuplicateTransactions', type: 'boolean' },
    { key: 'LaneId', type: 'number' },
    { key: 'TriPosCloudUrl', type: 'string' },
  ],
  'extdev-microservice': [
    { key: 'Scale', type: 'scaleConfig' },
    { key: 'Display', type: 'customerDisplayConfig' },
  ],
};
